module.exports = __webpack_public_path__ + "static/media/audio.c6000d57.svg";